import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export class GetSessionsWithPaginationService {
  async run(params: parmsRomms) {
    const response :any= await getByQuery<any[]>(`${services.analytics}/sessions-with-pagination`, params);
    return  {data:response.data.data, ...response.data.pagination};
  };
};